import React from "react";
import { useSteps } from "./steps/useSteps";
import useFormState from "./useFormState";
import clsx from "clsx";
import useFormActions from "./useFormActions";

export default function SubscriptionFooter() {
	const { step, isCreateUserStep, isLastStep, onPrevStepChange } = useSteps();
	const { onLeaveForm } = useFormActions();
	const { error, loading } = useFormState();

	return (
		<div className={clsx("step-footer", { error })}>
			{step !== 0 && !isCreateUserStep && (
				<button
					type="button"
					className="btn btn--secondary"
					onClick={onPrevStepChange}
				>
					Back
				</button>
			)}
			{isCreateUserStep && (
				<button
					type="button"
					className="btn btn--secondary"
					onClick={onLeaveForm}
				>
					I&apos;d rather not
				</button>
			)}
			<div className="btn-wrapper">
				{error && (
					<span className="error-text" role="alert">
						{error}
					</span>
				)}
				<button
					type="submit"
					className="btn btn--primary"
					form="subscription-form"
				>
					{isLastStep
						? loading
							? "Submitting..."
							: "Submit"
						: "Next"}
				</button>
			</div>
		</div>
	);
}
